import { useAppSelector } from "app/hooks";
import { getAuthActionState } from "app/reducers/authSlice";
import { UserRole } from "interfaces/User";
import React from "react";
import {
  Redirect,
  Route,
  RouteComponentProps,
  RouteProps,
} from "react-router-dom";

import { NAVIGATOR } from "./index";

interface PrivateRouteProps extends Omit<RouteProps, "component"> {
  role?: string;
  component: React.FunctionComponent<RouteComponentProps>;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: RouteComponent,
  role,
  ...props
}) => {
  const { user } = useAppSelector(getAuthActionState);
  const token = localStorage.getItem("token");

  return (
    <Route
      {...props}
      render={(routeProps) => {
        if (!user && !token) {
          return <Redirect to={NAVIGATOR.signIn} />;
        }
        if (role && user?.role && user.role !== role) {
          return user.role === UserRole.admin ? (
            <Redirect to={NAVIGATOR.home} />
          ) : (
            <Redirect to={NAVIGATOR.users} />
          );
        }
        return React.createElement(RouteComponent, routeProps);
      }}
    />
  );
};

export default PrivateRoute;
